export enum PlaidSequenceSteps {
  link_token = 'link_token',
  iframe = 'iframe',
  success = 'success',
}